import { useState, createContext, useContext } from "react";

const AuthContext = createContext(null);

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    // ✅ this runs BEFORE the first paint
    const token =
      localStorage.getItem("adminToken") ||
      sessionStorage.getItem("adminToken");
    return token ? { token } : null;
  });


  const setAuthToken = (token) => {
    sessionStorage.setItem('adminToken', token);
    localStorage.removeItem('adminToken');
    setUser({ token });
  };

  const logout = () => {
    localStorage.removeItem('adminToken');
    sessionStorage.removeItem('adminToken');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setAuthToken, logout, loading: false }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

export default AuthProvider;
